const init = {
    startDate: { value: '', valid: true },
    startTime: { value: '', valid: true },
    endDate: { value: '', valid: true },
    endTime: { value: '', valid: true },
};
export default init;
